export class QCPositionPlacementRequest{

    reactionPlateId:string;

    selectedQuadrant:string;
}